// extracted by mini-css-extract-plugin
export default {"selectListContainer":"EmailTeamsForm_selectListContainer__BfkHf","invitedTeamsCount":"EmailTeamsForm_invitedTeamsCount__gNDd1"};